import React, {Component} from 'react'

import SignupForm from '../../components/SignupForm'

export default class Howitworks extends Component {
  render() {
    return (
      <div id="anchor-howitworks" className=" grid-xl pt-2 th-home--mobiletop" style={{marginBottom: '0rem'}}>
        <div
          className=" container grid-xl py-16 th-how-features-mob"
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '.5rem',
            paddingBottom: '6rem',
            paddingTop: '0rem',
          }}>
          <div className="container grid-xl text-center">
            {/* <p className="h1  th-home--mobilefonth1" style={{color: '#4ABF62'}}>
              How it Works
            </p>
            <p className="h4 th-home--mobilefonth4 th-home--padmob" style={{color: '#00414b', marginBottom: '3rem'}}>
              Cooperating agents create a consistent experience for their clients
            </p> */}

            <div className="container grid-xl th-home--splash-content-3box">
              <div class="container grid-xl" style={{marginLeft: '-5px'}}>
                <div class="columns   text-center">
                  <div
                    class="column   col-md-12  bg-white py-6"
                    style={{borderRadius: '10px', boxShadow: ' 0px 0px 8px rgba(0, 0, 0, 0.1)', margin: '5px', color: '#232323'}}>
                    <div class="container" style={{maxWidth: '40%'}}>
                      <img
                        class="img-responsive img-fit-contain p-4"
                        src="https://cdn2.hubspot.net/hubfs/4744876/Design%20Assets/icons/Share%20Final%20Icon%2000a6d4@1x.png"
                        alt="service image"
                        style={{margin: '-20px 0'}}
                      />
                    </div>
                    <p style={{fontSize: '1.3rem', textAlign: 'center'}}>Educate Clients</p>
                    <p style={{fontSize: '.8rem', textAlign: 'center', color: '#666666'}}>Create Listing Information Packets</p>
                  </div>

                  <div
                    class="column col-md-12  bg-white py-6"
                    style={{borderRadius: '10px', border: '0px solid #000000', margin: '5px', boxShadow: ' 0px 0px 8px rgba(0, 0, 0, 0.1)', color: '#232323'}}>
                    <div class="container" style={{maxWidth: '40%'}}>
                      <img
                        class="img-responsive img-fit-contain p-4"
                        src="https://cdn2.hubspot.net/hubfs/4744876/Design%20Assets/icons/Activity%20Icon%2000a6d4@1x.png"
                        alt="service image"
                        style={{margin: '-20px 0'}}
                      />
                    </div>
                    <p style={{fontSize: '1.3rem', textAlign: 'center'}}>Monitor Interest</p>
                    <p style={{fontSize: '.8rem', textAlign: 'center', color: '#666666'}}>Track Activity With Buyer Interest Reports</p>
                  </div>

                  <div
                    class="column col-md-12  bg-white py-6"
                    style={{borderRadius: '10px', boxShadow: ' 0px 0px 8px rgba(0, 0, 0, 0.1)', margin: '5px', color: '#232323'}}>
                    <div class="container" style={{maxWidth: '40%'}}>
                      <img
                        class="img-responsive img-fit-contain p-4"
                        src="https://cdn2.hubspot.net/hubfs/4744876/Design%20Assets/icons/Offers%20Final%20Icon%2000a6d4@1x.png"
                        alt="service image"
                        style={{margin: '-20px 0'}}
                      />
                    </div>
                    <p style={{fontSize: '1.3rem', textAlign: 'center'}}>Manage Offers</p>
                    <p style={{fontSize: '.8rem', textAlign: 'center', color: '#666666'}}>Offers the Right Way, Your Way</p>
                  </div>
                </div>
              </div>
            </div>

            {/* <img
              className=" img-responsive container grid-lg"
              src="https://cdn.disclosures.io/assets/Marketing/ios+images/Activity+Photo+Computer+Hi+Rez.png"
              alt="Disclosures.io"
              width="950"
              height="auto"
            /> */}
          </div>

          {/* <div className=" th-home--mobiletop-howit " style={{marginTop: '3rem'}}>
            <div className=" container grid-sm ">
              <a href="#how-mod" className="btn btn-block" style={{border: '0px #cdcdcd solid'}}>
                <i className="fas fa-list-ul" style={{color: '#00a6d4'}} /> &nbsp; See Features
              </a>
              <div className="modal modal-xl" id="how-mod">
                <a href="/demo#anchor-demohow" className="modal-overlay" aria-label="Close" />
                <div className="modal-container " role="document">
                  <div className="modal-header">
                    <a href="/demo#anchor-demohow" className="btn btn-clear float-right" aria-label="Close" />
                    <div className="modal-title text-primary text-center">
                      Keep everything in one place and get to the offers, <i>faster.</i>
                    </div>
                  </div>
                  <div className="modal-body">
                    <div className="columns mt-0 " id="btn-pro3">
                      <div className="column  col-12 col-sm-12 col-md-10 col-xl-12 col-mx-auto" id="anchor-dteams">
                        <div className="th-home--plan  text-center ">
                          <div class="columns p-0">
                            <div class="column col-4 col-xs-12">
                              <ul
                                className=" th-home--planul"
                                style={{
                                  listStyleType: 'none',
                                  flex: 1,
                                  lineHeight: '.9rem',
                                  textAlign: 'left',

                                  color: '#00414b',
                                  fontSize: '.75rem',
                                }}>
                                <li style={{fontWeight: 'bolder'}}>Pre-Market</li>
                                <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                                  <li>Easy TC/Assistant access</li>
                                  <li>Seller Signature Import</li>
                                  <li>Create comprehensive Property Info Packets</li>
                                  <li>Scan documents</li>
                                  <li>Save custom document templates </li>
                                </ul>
                              </ul>
                            </div>
                            <div class="column col-4 col-xs-12">
                              <ul
                                className="  th-home--planul"
                                style={{
                                  listStyleType: 'none',
                                  flex: 1,
                                  lineHeight: '.9rem',
                                  textAlign: 'left',

                                  color: '#00414b',
                                  fontSize: '.75rem',
                                }}>
                                <li style={{fontWeight: 'bolder'}}>On-Market</li>
                                <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                                  <li>Share Unlimited Property Info Packets</li>
                                  <li>Sharable link for marketing materials</li>
                                  <li>Buyer Interest Reports (activity tracking)</li>
                                  <li>Broadcast updates to viewers </li>
                                  <li>Blind copy mass messaging to clients </li>
                                </ul>
                              </ul>
                            </div>
                            <div class="column col-4 col-xs-12">
                              <ul
                                className="  th-home--planul"
                                style={{
                                  listStyleType: 'none',
                                  flex: 1,
                                  lineHeight: '.9rem',
                                  textAlign: 'left',

                                  color: '#00414b',
                                  fontSize: '.75rem',
                                }}>
                                <li style={{fontWeight: 'bolder'}}>Offers</li>
                                <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                                  <li>Receive offers</li>
                                  <li>Submit offers</li>
                                  <li>Accept offers</li>
                                  <li>Automatic offers terms comparison sheet</li>
                                  <li>Custom offers dashboard for sellers&nbsp;</li>
                                </ul>
                              </ul>
                            </div>
                          </div>

                          <div class="columns p-0">
                            <div class="column col-4 col-xs-12">
                              <ul
                                className="th-home--planul "
                                style={{
                                  listStyleType: 'none',
                                  flex: 1,
                                  lineHeight: '.9rem',
                                  textAlign: 'left',

                                  color: '#00414b',
                                  fontSize: '.75rem',
                                }}>
                                <li style={{fontWeight: 'bolder'}}>Administrative</li>
                                <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                                  <li>Unlimited space (no fee for storage)</li>
                                  <li>Easy TC/Assistant access</li>
                                  <li>DocuSign integration</li>
                                  <li>Easy export of all data & contacts</li>
                                  <li>iOS App</li>
                                  <li>Additional iOS app functionality</li>
                                  <li>Custom branding</li>
                                </ul>
                              </ul>
                            </div>

                            <div class="column col-4 col-xs-12">
                              <ul
                                className="  th-home--planul"
                                style={{
                                  listStyleType: 'none',
                                  flex: 1,
                                  lineHeight: '.9rem',
                                  textAlign: 'left',

                                  color: '#00414b',
                                  fontSize: '.75rem',
                                }}>
                                <li style={{fontWeight: 'bolder'}}>Support</li>
                                <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                                  <li>Help center guides and training</li>
                                  <li>1-on-1 customer support</li>
                                  <li style={{color: '#e2e2e2'}}>Team training </li>
                                </ul>
                              </ul>
                            </div>
                            <div class="column col-4 col-xs-12">
                              <ul
                                className="  th-home--planul"
                                style={{
                                  listStyleType: 'none',
                                  flex: 1,
                                  lineHeight: '.9rem',
                                  textAlign: 'left',

                                  color: '#00414b',
                                  fontSize: '.75rem',
                                }}>
                                <li style={{fontWeight: 'bolder'}}>Team/Brokerage Control</li>
                                <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                                  <li>Team training </li>
                                  <li>Advanced Top Down Branding</li>
                                  <li>Multiple user privileges (for assistants and TC’s)</li>
                                  <li>Team collaboration on listings</li>
                                  <li>Custom user and performance reports</li>
                                  <li>Single-Sign-On available (SSO)</li>
                                </ul>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer"></div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    )
  }
}
